import { useEffect, useState } from 'react';

export const useDevice = () => {
  const [device, setDevice] = useState('mobile');

  useEffect(() => {
    const onResize = () => {
      setDevice(global?.innerWidth >= global?.innerHeight ? 'desktop' : 'mobile');
    };

    onResize();

    global.addEventListener('resize', onResize);
    return () => global.addEventListener('resize', onResize);
  }, []);

  return device;
};
